import type { RenderNode } from "../../../util/src/layout-compiler/types.js";

/**
 * Indexes every render node in the tree by its runtime key (`key` or `id`).
 */
export function collectRenderNodesByKey(
  nodes: RenderNode[],
  map = new Map<string, RenderNode>(),
): Map<string, RenderNode> {
  for (const node of nodes) {
    const key = node.key ?? node.id;
    map.set(key, node);

    if (node.kind === "container" || node.kind === "layoutList") {
      collectRenderNodesByKey(node.children, map);
    }
  }

  return map;
}
